module.exports = __webpack_public_path__ + "static/media/search-icon.1aca51f3.svg";